export enum TimeEntryType {
  Unknown = 0,
  Work = 1,
  Transport = 2,
}
